import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { selectHasExecutePermissions } from 'store/selectors/user'

import ProgramDeadlines from './ProgramDeadlines'

const FunderProgramDescription = ({ funderProgram, gotoGrantFit }) => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)

  const hasExecutePermissions = useSelector(selectHasExecutePermissions)

  return (
    <div className="profile-programs-description">
      {hasExecutePermissions && (
        <div className="check-fit-row">
          <Button variant="contained" onClick={gotoGrantFit}>
            {t.funder.grantFit.programsCheckFit}
          </Button>
        </div>
      )}
      {funderProgram.description && (
        <div dangerouslySetInnerHTML={{ __html: funderProgram.description }} />
      )}
      <div className="extra_contact">
        {funderProgram.programContacts?.map((contact, index) => (
          <div key={index}>
            <h4>{t.funder.programContact}</h4>
            <div dangerouslySetInnerHTML={{ __html: contact.name }} />
          </div>
        ))}
      </div>
      <ProgramDeadlines funderProgram={funderProgram} />
    </div>
  )
}

export default FunderProgramDescription
